export default __webpack_public_path__ + "static/media/functional-durable-materials.45d28e43.jpg";